// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role

console.log("pre-dom content loaded")

window.addEventListener("DOMContentLoaded", () => {
	console.log("post-dom content loaded")
	const tabs = document.querySelectorAll('[role="tab"]')
	const tabList = document.querySelector('[role="tablist"]')
	const tabPanels = document.querySelectorAll('[role="tabpanel"]')

	if (tabPanels) {
		tabPanels.forEach((panel, i) => {
			// set 'hidden' attribute to all tabs but the first

			if (i !== 0) {
				panel.setAttribute("hidden", true)
			}
		})
	}

	if (tabs) {
		// Add a click event handler to each tab
		tabs.forEach((tab, i) => {
			tab.addEventListener("click", changeTabs)
			tab.setAttribute("href", "javascript:;")
		})
	}

	if (tabList) {
		// Enable arrow navigation between tabs in the tab list
		let tabFocus = 0

		tabList.addEventListener("keydown", e => {
			// Move right
			if (e.keyCode === 39 || e.keyCode === 37) {
				tabs[tabFocus].setAttribute("tabindex", -1)
				if (e.keyCode === 39) {
					tabFocus++
					// If we're at the end, go to the start
					if (tabFocus >= tabs.length) {
						tabFocus = 0
					}
					// Move left
				} else if (e.keyCode === 37) {
					tabFocus--
					// If we're at the start, move to the end
					if (tabFocus < 0) {
						tabFocus = tabs.length - 1
					}
				}

				tabs[tabFocus].setAttribute("tabindex", 0)
				tabs[tabFocus].focus()
			}
		})
	}
})

function changeTabs(e) {
	const target = e.target
	const parent = target.parentNode
	const grandparent = parent.parentNode

	// Remove all current selected tabs
	parent
		.querySelectorAll('[aria-selected="true"]')
		.forEach(t => t.setAttribute("aria-selected", false))

	// Set this tab as selected
	target.setAttribute("aria-selected", true)

	// Hide all tab panels
	grandparent
		.querySelectorAll('[role="tabpanel"]')
		.forEach(p => p.setAttribute("hidden", true))

	// Show the selected panel
	grandparent.parentNode
		.querySelector(`#${target.getAttribute("aria-controls")}`)
		.removeAttribute("hidden")
}
